import { jsPDF } from "jspdf";

export default function genPDFDeskjet({
  datosfactura,
  detallefactura,
  isCredito,
  TextoNumber,
  sum1,
  sum2,
  impx,
  impy,
}) {
  const doc = new jsPDF({
    unit: "px",
    orientation: "landscape",
    format: "A4",
  });

  // ✅ Función formateadora de miles
  const formatMiles = (num) => {
    if (num === undefined || num === null || num === "") return "";
    return Number(num).toLocaleString("es-PY");
  };

  // ✅ Manejo de valores nulos o faltantes
  datosfactura.direccion = datosfactura.direccion || "";
  datosfactura.telefono = datosfactura.telefono || "";
  datosfactura.iva5 = datosfactura.iva5 ?? datosfactura.gravado05;
  datosfactura.iva10 = datosfactura.iva10 ?? datosfactura.gravado10;
  datosfactura.totalmonto = datosfactura.totalmonto ?? datosfactura.totalFactura;
  datosfactura.ivatotal =
    datosfactura.ivatotal ??
    Number(datosfactura.gravado05 + datosfactura.gravado10);
  datosfactura.Subtotal5 = datosfactura.Subtotal5 ?? sum1;
  datosfactura.Subtotal10 = datosfactura.Subtotal10 ?? sum2;
  datosfactura.fechafactura =
    datosfactura.fechafactura ?? new Date().toLocaleDateString();

  const writePage = (offsetX = 0, offsetY = 0) => {
    doc.setTextColor(84, 126, 179);
    let gapRow = 20;

    let isContado = isCredito;
    let casillaX = offsetX + 265 + (isContado ? 28 : 0);

    doc.setFont(undefined, "bold");
    doc.setFontSize(8);
    doc.text("X", casillaX + 10, offsetY + 58);

    doc.setFontSize(6);
    doc.setFont(undefined, "normal");

    // ✅ Datos de cabecera
    doc.text(datosfactura.fechafactura, offsetX + 55, offsetY + 58);
    doc.text(datosfactura.razonsocial, offsetX + 68, offsetY + 67);
    doc.text(datosfactura.ruc, offsetX + 51, offsetY + 76);
    doc.text(datosfactura.direccion, offsetX + 138, offsetY + 76);
    doc.text(datosfactura.telefono, offsetX + 263, offsetY + 76);

    // ✅ Detalle de ítems
    for (const [index, obj] of detallefactura.entries()) {
      addRow(obj, offsetX - 3, offsetY + 103 + index * gapRow);
    }

    // ✅ Subtotales y totales con separador de miles
    doc.text(formatMiles(datosfactura.Subtotal5), offsetX + 230, offsetY + 413);
    doc.text(formatMiles(datosfactura.Subtotal10), offsetX + 270, offsetY + 413);

    doc.text(TextoNumber, offsetX + 68, offsetY + 421, { maxWidth: 180 });
    doc.text(formatMiles(datosfactura.totalmonto), offsetX + 269, offsetY + 423);

    doc.text(formatMiles(datosfactura.iva5), offsetX + 100, offsetY + 437);
    doc.text(formatMiles(datosfactura.iva10), offsetX + 165, offsetY + 437);
    doc.text(formatMiles(datosfactura.ivatotal), offsetX + 240, offsetY + 437);
  };

  // ✅ Fila de detalle
  const addRow = (data, x = 0, y) => {
    doc.setFont(undefined, "bold");
    doc.setFontSize(8);
    doc.text(String(data.cantidad), x + 20, y);
    doc.text(String(data.artcod), x + 42, y);

    doc.setFont(undefined, "normal");
    doc.setFontSize(8);
    doc.text(data.producto, x + 66, y, { maxWidth: 70 });

    // ✅ Aplicamos separador de miles
    doc.text(formatMiles(data.precio), x + 170, y);
    doc.text(formatMiles(data.exenta), x + 203, y);
    doc.text(formatMiles(data.cinco), x + 233, y);
    doc.text(formatMiles(data.diez), x + 269, y);
  };

  // ✅ Doble copia (original y duplicado)
  writePage(impx, impy);
  writePage(336 + impx, impy);

  doc.autoPrint();
  doc.output("dataurlnewwindow");
}